import React, { useEffect, useState } from 'react';
import Modal from '../Modal'; // импорт вашего модального окна
import dialogGif from '../../assets/images/mainmenu/dialog.gif';
import dialogPng from '../../assets/images/mainmenu/dialog.png';
import igraGif from '../../assets/images/mainmenu/igra.gif';
import igraPng from '../../assets/images/mainmenu/igra.png';
import igra3Gif from '../../assets/images/mainmenu/igra3.gif';
import igra3Png from '../../assets/images/mainmenu/igra3.png';
import lernenGif from '../../assets/images/mainmenu/lernen.gif';
import lernenPng from '../../assets/images/mainmenu/lernen.png';
import testGif from '../../assets/images/mainmenu/test.gif';
import testPng from '../../assets/images/mainmenu/test.png';
import test2Gif from '../../assets/images/mainmenu/test2.gif';
import test2Png from '../../assets/images/mainmenu/test2.png';

import styles from './MainMenu.module.css';
import { useAppConfig } from '../../context/AppConfigContext'; // Импортируем хук

const rawItems = [
  { key: 'dialog', gif: dialogGif, png: dialogPng, duration: "3.0" },
  { key: 'igra', gif: igraGif, png: igraPng, duration: "9.77" },
  { key: 'igra3', gif: igra3Gif, png: igra3Png, duration: "2.0" },
  { key: 'lernen', gif: lernenGif, png: lernenPng, duration: "1.44" },
  { key: 'test', gif: testGif, png: testPng, duration: "6.67" },
  { key: 'test2', gif: test2Gif, png: test2Png, duration: "4.0" }
];

const ORDER = ['lernen', 'dialog', 'igra', 'test'];

const groupItems = (items) => {
  const groups = {};
  items.forEach(item => {
    const key = item.key; // используем явно
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  });

  return ORDER.filter((key) => groups[key]).map((key) => ({
    key,
    variants: groups[key],
  }));
};


const MIN_DISPLAY_TIME = 2500; // 2 секунды

const MainMenu = ({ onSelect, phrasesCount, onLevelChange, selectedLevel, onGoToVip }) => {

  const [activeIndex, setActiveIndex] = useState(0);
  const [cycleIndices, setCycleIndices] = useState({});
  const { t, userInfo } = useAppConfig();
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState(''); 
  const [hintIndex, setHintIndex] = useState(0);

  const vipLevel = userInfo?.vip || 0;

  let isTestLocked = phrasesCount < 10; // || userInfo.userId == "96186835-c831-47f3-bdfa-cf8951f1f4aa"
  const levels = ['A1', 'A2.1', 'A2.2', 'B1.1', 'B1.2', 'B1.3', 'B2'];

  isTestLocked = false; // временно разблокируем тест для всех, так как он уже не зависит от количества фраз

  const groupedItems = React.useMemo(() => groupItems(rawItems), []);	

	// проверка: показываем подсказку только если phrasesCount < 5000 и уровень A1
	const showHint = phrasesCount < 5000 && selectedLevel === 'A1';

	useEffect(() => {
	  if (!showHint) return; // больше не показываем смену текста

	  const interval = setInterval(() => {
		setHintIndex((prev) => (prev === 0 ? 1 : 0));
	  }, 5000);

	  return () => clearInterval(interval);
	}, [showHint]);


	const playCaption = showHint && hintIndex === 0
	  ? t.menu.press
	  : t.menu.play;


	const nameMap = {
	  lernen: t.menu.learn,
	  dialog: t.menu.dialog,
	  igra: playCaption,
	  test: t.menu.testSimple, 
	};
	  
  useEffect(() => {

    const currentItem = groupedItems[activeIndex];
    const currentVariantIndex = cycleIndices[currentItem.key] || 0;
    const currentVariant = currentItem.variants[currentVariantIndex];
    const duration = Math.max(parseFloat(currentVariant.duration) * 1000 || 3000, MIN_DISPLAY_TIME);

    const timer = setTimeout(() => {
      const nextIndex = (activeIndex + 1) % groupedItems.length;

      const nextCycleIndices = { ...cycleIndices };
      const group = groupedItems[activeIndex];
      const variantCount = group.variants.length;

      if (variantCount > 1) {
        const current = cycleIndices[group.key] || 0;
        nextCycleIndices[group.key] = (current + 1) % variantCount;
      }

      setCycleIndices(nextCycleIndices);
      setActiveIndex(nextIndex);
    }, duration);

    return () => clearTimeout(timer);
  }, [activeIndex, cycleIndices]);

	  const handleLevelClick = (level) => {
		if (['B1.2', 'B1.3', 'B2'].includes(level) && ![6,7].includes(vipLevel)) {
		  setModalText(t.menu.levelLocked);
		  setShowModal(true);
		  return;
		}
		onLevelChange(level);
	  };
	  
	return (
	  <>
		<div className={styles.menu}>
			{/* Первый ряд: Игра и Тест */}
			<div className={styles.row}>
			  {groupedItems
				.filter(group => ['igra', 'test'].includes(group.key))
				.map(group => {
				  const variantIndex = cycleIndices[group.key] || 0;
				  const variant = group.variants[variantIndex];
				  const isActive = groupedItems.indexOf(group) === activeIndex;
				  const imageSrc = isActive ? variant.gif : variant.png;

				  return (
					<div
					  key={group.key}
					  className={`${styles.block} ${isActive ? styles.active : ''} ${
						group.key === 'test' && isTestLocked ? styles.locked : ''
					  }`}
					  onClick={() => {
						if (group.key === 'test' && isTestLocked) return;
						onSelect?.(group.key);
					  }}
					>
					  <img src={imageSrc} alt={group.key} className={styles.image} />

					  {/* Селектор уровней только для "igra" */}
						{group.key === 'igra' && (
						  <>
						  {phrasesCount < 5000 && selectedLevel === 'A1' && (
							  <div className={styles.levelOverlayTitle}>
								<span className={styles.arrow}>↓</span>
								{t.menu.choice}
								<span className={styles.arrow}>↓</span>
							  </div>
							)}

						  <div className={styles.levelArea}>
							{/* Селектор уровней */}
							<div className={styles.levelSelector}>
							  {levels.map((level) => {
								const isActiveLevel = selectedLevel === level;
								return (
								  <div
									key={level}
									className={`${styles.levelCircle} ${isActiveLevel ? styles.levelActive : ''}`} 
									onClick={(e) => {
									  e.stopPropagation();
									  handleLevelClick(level);
									}}
								  >
									{isActiveLevel ? level : ''}
								  </div>
								);
							  })}
							</div>
						  </div>
						  </>
						)}

					  <div className={styles.caption}>
						{nameMap[group.key] || group.key}
						{group.key === 'test' && isTestLocked && (
						  <>
							<span className={styles.lockIcon}>🔒</span>
							<div className={styles.lockNote}>{t.menu.lockNote}</div>
						  </>
						)}
					  </div>
					</div>
				  );
				})}
			</div>

		  {/* Красивый разделитель */}
		  <div className={styles.separator}>
			<span>{t.menu.auxModules || 'Вспомогательные модули'}</span>
		  </div>

		  {/* Второй ряд: Lernen и Dialog */}
		  <div className={styles.row}>
			{groupedItems
			  .filter(group => ['lernen', 'dialog'].includes(group.key))
			  .map(group => {
				const variantIndex = cycleIndices[group.key] || 0;
				const variant = group.variants[variantIndex];
				const isActive = groupedItems.indexOf(group) === activeIndex;
				const imageSrc = isActive ? variant.gif : variant.png;

				return (
				  <div
					key={group.key}
					className={`${styles.block} ${isActive ? styles.active : ''}`}
					onClick={() => onSelect?.(group.key)}
				  >
					<img src={imageSrc} alt={group.key} className={styles.image} />
					<p className={styles.caption}>{nameMap[group.key] || group.key}</p>
				  </div>
				);
			  })}
		  </div>
		</div>
		{showModal && (
		  <Modal
			title={t.menu.modalTitle}         // мультиязычный заголовок
			confirmText={t.menu.buyPremium}   // мультиязычная кнопка
			onClose={() => setShowModal(false)}
			onConfirm={() => {
			  setShowModal(false);
			  onGoToVip?.();
			}}
		  >
			{modalText}
		  </Modal>
		)}
	  </>
	);	
};

export default MainMenu;